<template>
	<hr class="border-discord-200 border-2 w-full m-2">
</template>

<script lang="ts">
export default {
	name: 'DividerElement',
}
</script>
